import { useContext } from 'react';
import { NoticeTopBar } from './index';
import ImpersonateNotice from './ImpersonateNotice';
import { SessionContext } from 'contexts/session';
import { TopContainer } from './ImpersonatedNotification.styles';

const ImpersonatedNotification = (): JSX.Element | null => {
  const { user, account, actions, isImpersonated } = useContext(SessionContext);

  const handleEndImpersonation = () => {
    actions.impersonate();
  };

  if (!isImpersonated) return null;

  return (
    <TopContainer>
      <NoticeTopBar>
        <ImpersonateNotice user={user} account={account} onClose={handleEndImpersonation} />
      </NoticeTopBar>
    </TopContainer>
  );
};

export default ImpersonatedNotification;
